<template>
  <div class="main">
    <topImg
      title="更多机遇，更多精彩"
      img="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/historyHorner/banner_about.png"
    ></topImg>

    <div class="content">
      <div class="title">热招岗位</div>
      <div class="contentList">
        <div
          class="list"
          :class="{active: listIndex === index}"
          v-for="(item, index) of list"
          :key="item.title"
          @mouseleave="(res) => mouseLeave(res, index)"
          :ref="'list' + index"
        >
          <div class="site" id="isPC">
            <span>{{ item.site }}</span>
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_625f7577a3a2f/602311439.png"
              alt=""
            />
          </div>
          <div class="headline" id="isPC">{{ item.work }}</div>
          <div class="email" id="isPC">简历投递：growlib-hr@growlib.com</div>
          <div class="headline" id="isMobile">
            {{ item.work }} - {{ item.site }}
          </div>
          <div v-for="itemSon of item.desc" :key="itemSon.title">
            <div class="smallHeadline">{{ itemSon.title }}：</div>
            <div class="desc" v-for="itemSun of itemSon.detail" :key="itemSun">
              {{ itemSun }}
            </div>
          </div>
          <div class="look">
            <span>………</span>
            <div @click="look(listIndex=index)">
              <span>查看</span>
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_625f7577a080b/574637152.png"
                alt=""
              />
            </div>
          </div>
          <div class="detail">
            <div v-for="itemSon of item.desc" :key="itemSon.title">
              <div class="smallHeadline">{{ itemSon.title }}：</div>
              <div class="desc" v-for="itemSun of itemSon.detail" :key="itemSun">
                {{ itemSun }}
              </div>
            </div>
          </div>
          <div class="email" id="isMobile">
            简历投递：growlib-hr@growlib.com
          </div>
        </div>
        <!-- <div class="list listDetail" v-show="showCover"  @mouseover="res=>{mouseOver(res, 9999)}"
        @mouseleave="res=>mouseLeave(res, 9999)" ref="listDetail">
          <div class="site">{{ list[listIndex].site }}</div>
          <div class="headline">{{ list[listIndex].work }}</div>
          <div class="email">简历投递：growlib-hr@growlib.com</div>
          <div v-for="itemSon of list[listIndex].desc" :key='itemSon.title'>
            <div class="smallHeadline">{{ itemSon.title }}：</div>
            <div class="desc" v-for="itemSun of itemSon.detail" :key='itemSun'>{{ itemSun }}</div>
          </div>
          
        </div> -->
        <div
          class="cover"
          v-show="showCover"
          :class="{ coverFull: showCover }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          site: '北京（酒仙桥）',
          work: 'Unity3D工程师',
          desc: [
            {
              title: '岗位描述',
              detail: [
                '1、根据公司研发规划，完成基于unity引擎的VR/AR课件、应用软件的开发；',
                '2、开发中间件框架，兼容主流VR/AR/MR硬件平台。'
              ]
            },
            {
              title: '任职要求',
              detail: [
                '1、计算机相关专业，有扎实编程语言基础；',
                '2、熟悉unity相关知识，对引擎使用有一定经验；',
                '3、能够独立完成开发的任务，拥有一定的自学能力及解决问题能力；',
                '4、具有良好的编码习惯，严谨的编码风格；',
                '5、了解Android开发的相关知识，对计算机图形学及shader有一定理解者优先。'
              ]
            }
          ]
        },
        {
          site: '南昌（红谷滩）',
          work: '3D美术设计师',
          desc: [
            {
              title: '岗位职责',
              detail: [
                '1、为场景生态、环境创建优质的 3D 模型资源（包含建筑、小品、室内、角色等）和 PBR 材质；',
                '2、配合组内同事共同建立产品中3D模型资源的品质标准；',
                '3、与技术模块同事沟通，以保证模型在unity中的整体表现，包括但不限于模型、材质、灯光等；'
              ]
            },
            {
              title: '任职要求',
              detail: [
                '1、专科及以上设计、艺术类专业毕业；',
                '2、有过3d项目经验，并且能独立完成项目中的3d美术任务。',
                '3、对模型造型、布线、结构和轮廓等3d设计语言有自己的理解；',
                '4、熟练掌握使用 Maya 或 3Ds max，Zbrush，Substance Painter 等相关软件进行 3D 资产制作，同时对 PBR 美术生产管线的相关技术信息以及开发工具有一定了解和掌握；',
                '5、熟悉 unity 等次世代引擎效果呈现及模型制作方法；'
              ]
            }
          ]
        },
        {
          site: '北京（酒仙桥）',
          work: '高级3D美术设计师',
          desc: [
            {
              title: '岗位职责',
              detail: [
                '1，负责项目中角色、场景模型、贴图制作，动画绑定；',
                '2、负责项目组中模型资源的整理、导出及维护；',
                '3、与技术模块同事沟通，以保证角色在Unity中的整体表现，包括但不限于模型、动画，贴图材质、灯光等。',
                '4，与外部团队沟通，指定制作规范和流程。'
              ]
            },
            {
              title: '任职要求',
              detail: [
                '1、5年以上3D次时代（pbr流程）模型工作经验，至少全程参与2款完整项目；熟悉整个流程并且擅长其中某一环节的制作。',
                '2、具有扎实的美术基本功底（美院等美术相关专业毕业优先），能够掌握多种3d风格不同类型模型的制作，对题材转换没有太大障碍；',
                '3、熟练运用MAX/maya等三维软件，以及ZBrush，substance painter等主流的次时代制作工具，熟悉Unity引擎及其他相关绘图软件；并熟悉unity3d的shader，灯光，渲染等环节，能够调出相应的效果。也能根据产品需要进行美术方面的创新和尝试',
                '4、热爱cg和设计，主动性高，乐于接受挑战，对cg行业的软件技术更新能够及时了解和学习，并且能够及时运用到项目中；'
              ]
            }
          ]
        },
        {
          site: '北京（酒仙桥）',
          work: '产品经理',
          desc: [
            {
              title: '岗位职责',
              detail: [
                '1、负责教育业务的某产品线的平台产品设计',
                '2、通过对行业和竞品分析，找到商业可行性，进行产品设计与规划；',
                '3、根据业务发展，不断提高产品的服务能力和商业价值，保证产品在行业的竞争力；',
                '4、与各部门紧密合作，推进产品的实施与迭代。'
              ]
            },
            {
              title: '任职要求',
              detail: [
                '1、4年以上平台和后端产品工作经验；',
                '2、具备较强的商业分析、竞争策略和平台化方案能力；',
                '3、优秀的用户体验设计能力，对教育行业用户行为和心理有深刻的感知；',
                '4、具备较强的责任心，能自我驱动、有担当；',
                '5、具备优秀的沟通技巧，较强的团队协作意识，能独立推进项目并落地；',
                '6、能够独立按时完成工作，逻辑清晰，并善于解决问题；'
              ]
            }
          ]
        },
        {
          site: '北京（酒仙桥）',
          work: '中高职业务销售总监',
          desc: [
            {
              title: '岗位职责',
              detail: [
                '1、为公司产品提供综合服务，制定团队销售策略及业务拓展计划，新老客户开发与维护。',
                '2、制定业务目标，组织业务团队在公司已有市场和客户深厚基础上积极拓展渠道和业务，完成项目的跟踪落地等各项事宜，跟踪回款及时性，持续稳定增长。',
                '3、主持客户的业务谈判及成交，落实客户货款的回收，创建长期、良好、稳固的区域客户关系拓展公司客户资源，协调公司资源提供各种合作服务支持。',
                '4、根据公司的长远发展需要，组织开展销售团队建设，负责团队目标绩效管理，支持销售目标的达成。',
                '5、确保团队销售业绩的达成与销售费用的合理分配与控制。'
              ]
            },
            {
              title: '任职要求',
              detail: [
                '1、大专及以上学历，5年以上教育行业产品销售经验；28-35岁左右，男女不限；',
                '2、5年以上TOB、运营商或中高职公立学校教育产品，全国、大区渠道管理与运营经验；',
                '3、具有较强的组织、协调沟通以及谈判能力；',
                '4、具备深度开发客户的能力，具备统筹及细化的能力；',
                '5、超强的文案功底；能准确了解客户需求，设计解决方案，完成客户多样性需求的对接工作；',
                '6、熟悉招标流程及强大的合作资源；',
                '7、勇于接受挑战，富有团队精神，能承受较大的工作压力。'
              ]
            }
          ]
        },
        {
          site: '北京 成都 南昌',
          work: '中高职业务销售经理',
          desc: [
            {
              title: '岗位职责',
              detail: [
                '1、开发教育产品直客与渠道资源推广公司产品，促进销售业绩的实现；',
                '2、协调内部资源制定售前方案，以及帮助渠道对终端用户进行产品演示；',
                '3、项目确认后，准备所需的招投标或其他确认资料；',
                '4、维护好渠道与终端用户的关系，分析渠道与学校等用户提的意见并进行反馈。'
              ]
            },
            {
              title: '任职要求',
              detail: [
                '1.大专以上学历，具有教育装备或互联网教育行业2年以上销售经验；',
                '2.具有一定的市场分析及判断能力，思维敏捷，良好的客户服务意识；',
                '3.二年以上代理商或直接客户销售经验，普教行业虚拟仿真、虚拟现实项目背景优先；',
                '4.执行力强，理解力强，有直客资源并有现行集成类项目优先。'
              ]
            }
          ]
        },
        {
          site: '北京',
          work: '培训业务销售总监',
          desc: [
            {
              title: '岗位职责',
              detail: [
                '1、为公司产品提供综合服务，协助销售副总裁制定业务目标，团队销售策略及业务拓展计划，促进销售业绩的实现；',
                '2、带领团队在公司已有市场的基础上积极拓展业务，完成项目的跟踪落地等各项事宜，跟踪回款及时性，持续稳定增长。',
                '3、主持客户的业务谈判及成交，落实客户货款的回收，创建长期、良好、稳固的区域客户关系。',
                '4、根据公司的长远发展需要，组织开展销售团队建设，负责团队人员激励，目标绩效管理，支持销售目标的达成。'
              ]
            },
            {
              title: '任职要求',
              detail: [
                '1、大专以上学历，5年以上虚仿行业销售经验，3年左右销售团队管理经验，中高职高校方向、虚拟仿真、虚拟现实vr,增强现实ar项目背景优先；',
                '2、有千万级项目运作经验，有较强的商业洞察力，对市场需求有一定敏感度，有强烈的成功欲望；',
                '3、具有较强的市场分析及营销能力，良好的人际沟通，协调，解决问题能力；',
                '4、有了解过虚拟现实行业，熟悉招投标流程优先考虑。'
              ]
            }
          ]
        },
        {
          site: '北京 成都 南昌 上海 杭州',
          work: '培训业务销售经理',
          desc: [
            {
              title: '岗位职责',
              detail: [
                '1、开发直客与渠道资源推广公司产品，促进销售业绩的实现；',
                '2、协调内部资源制定售前方案，以及帮助渠道对终端用户进行产品演示；',
                '3、项目确认后，准备所需的招投标或其他确认资料；',
                '4、维护好渠道与终端用户的关系，分析渠道与学校等用户提的意见并进行反馈。'
              ]
            },
            {
              title: '任职要求',
              detail: [
                '1、大专以上学历，三年以上B端销售经验，中高职，高校方向、虚拟仿真、虚拟现实vr,增强现实ar项目背景优先；',
                '2、有较强的商业洞察力，对市场需求有一定敏感度，有强烈的成功欲望；',
                '3、思维逻辑清晰，擅于表达，有一定的商务谈判能力；',
                '4、有直客资源并有现行集成类项目优先考虑。'
              ]
            }
          ]
        }
      ],
      listIndex: 0,
      showCover: false
    };
  },
  mounted() {},
  methods: {
    mouseOver(data, index) {
      console.log('进入', index, data);
      if (data.target.className != 'list') {
        // return
        let changeData = null;
        data.path.forEach(element => {
          if (element.className == 'list') {
            changeData = element;
          }
        });
        if (changeData == null) {
          return;
        }
        data = {
          target: changeData
        };
        console.log(changeData.offsetLeft);
      }
      this.listIndex = index;
      let target = data.target;
      let dom = this.$refs['listDetail'];
      console.log(dom.style, data, target.offsetLeft);
      dom.style.top = target.offsetTop + 'px';
      dom.style.left = target.offsetLeft + 'px';
      this.showCover = true;
    },
    mouseLeave(data, index) {
      this.listIndex = ''
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  background: #fff;
  padding-bottom: 100px;
  .content {
    width: 1200px;
    margin: 0 auto;
    .title {
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
      text-align: center;
      width: 100%;
      padding: 63px;
    }
    .contentList {
      display: flex;
      flex-wrap: wrap;
      margin-top: 30px;
      justify-content: space-between;
      position: relative;
      .list {
        width: 565px;
        height: 429px;
        margin-bottom: 50px;
        background: #ffffff;
        border-radius: 19px;
        padding: 33px 27px 17px 27px;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.5s;
        top: 0px;
        left: 0px;
        position: relative;
        .headline {
          font-size: 22px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 30px;
          position: relative;
        }
        .headline::after {
          content: "";
          position: absolute;
          left: 0;
          top: 40px;
          width: 27px;
          height: 4px;
          background: #ef623d;
          box-shadow: 0px 0px 10px -2px rgba(133, 133, 133, 0.66);
          border-radius: 2px;
          opacity: 0.59;
        }
        .email {
          font-size: 14px;
          font-weight: 400;
          color: #000000;
          line-height: 20px;
          margin-top: 36px;
          margin-bottom: 22px;
        }
        .smallHeadline {
          font-size: 14px;
          font-weight: 400;
          color: #707483;
          line-height: 20px;
          margin-top: 12px;
        }
        .desc {
          font-size: 14px;
          font-weight: 400;
          color: #000000;
          line-height: 22px;
          margin-top: 12px;
        }
        .site {
          position: absolute;
          top: 40px;
          right: 28px;
          line-height: 14px;
          span {
            font-size: 14px;
            font-weight: 400;
            color: #000000;
            line-height: 20px;
            vertical-align: middle;
          }
          img {
            margin-left: 6px;
            width: 14px;
            vertical-align: middle;
          }
        }
        .look {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          padding: 0px 27px 17px 27px;
          box-sizing: border-box;
          background: #fff;
          z-index: 2;
          > span {
            display: block;
            font-size: 14px;
            font-weight: 400;
            color: #444a62;
            line-height: 22px;
          }
          > div {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 86px;
            height: 32px;
            border-radius: 16px;
            border: 1px solid #f27529;
            margin-top: 17px;
            cursor: pointer;
            span {
              font-size: 12px;
              font-weight: 500;
              color: #f27529;
              line-height: 17px;
            }
            img{
              width: 16px;
            }
          }
        }
        .detail{
          width: 100%;
          background: linear-gradient(220deg, rgba(246, 140, 68, 1) 0%, #EF623D 100%);
          box-shadow: 0px 0px 10px -2px rgba(133, 133, 133, 0.66);
          border-radius: 19px;
          padding: 0 27px;
          box-sizing: border-box;
          position: absolute;
          bottom: 0;
          left: 0;
          overflow-y: scroll;
          transition: all .5s;
          height: 0;
          z-index: 2;
          opacity: 0;
          // display: none;
          scrollbar-width: none; /* firefox */
          -ms-overflow-style: none; /* IE 10+ */
          div{
            color: #fff;
          }
        }
        .detail::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
      }
      .active{
        box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.14);
        .detail{
          padding: 10px 27px 23px 27px;
          height: 299px;
          z-index: 2;
          opacity: 1;
          // display: block;
        }
      }
      .listDetail {
        height: auto;
        position: absolute;
        z-index: 2;
      }
      .cover {
        width: 100%;
        height: 100%;
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.7);
        transition: all 1s;
        opacity: 0;
      }
      .coverFull {
        opacity: 1;
      }
    }
  }
}
@media (max-width: 1000px) {
  .main {
    padding-bottom: 100px;
    .banner {
      height: 348px;
      .cover {
        padding-top: 192px;
        padding-left: 52px;
        > div {
          width: auto;
          .title {
            font-size: 34px;
            color: #ffffff;
            letter-spacing: 0;
            font-weight: 400;
          }
          .desc {
            font-size: 40px;
            color: #ffffff;
            letter-spacing: 0;
            font-weight: 500;
          }
        }
      }
    }
    .content {
      width: 100%;
      padding: 0 48px;
      .title {
        font-size: 40px;
        color: #5e5e5e;
        letter-spacing: 0;
        font-weight: 500;
        margin-top: 84px;
      }
      .line {
        margin-top: 22px;
        border: none;
        border-left: 170px solid #fdd917;
        border-right: 480px solid #c2bebe;
        height: 2px;
        width: 0px;
        position: relative;
        z-index: 2;
        margin-left: -13px;
      }
      .contentList {
        display: block;
        margin-top: 0;
        .list {
          width: 100%;
          padding: 0;
          box-shadow: none;
          height: auto;
          border-bottom: none;
          margin-bottom: 40px;
          .headline {
            font-size: 36px;
            color: #5e5e5e;
            letter-spacing: 0;
            line-height: 44px;
            font-weight: 400;
            margin-top: 40px;
          }
          .smallHeadline {
            font-size: 28px;
            color: #5e5e5e;
            letter-spacing: 0;
            text-align: justify;
            line-height: 40px;
            font-weight: 500;
            margin-top: 40px;
          }
          .desc {
            font-size: 28px;
            color: #8d8e9d;
            letter-spacing: 0;
            font-weight: 400;
            margin-top: 20px;
          }
          .email {
            font-size: 28px;
            color: #f27529;
            letter-spacing: 0;
            text-align: justify;
            line-height: 40px;
            font-weight: 400;
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
